module.exports = __webpack_public_path__ + "static/media/ODS2.96985c2e.jpeg";